"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGlUniformValue = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * wrapper for a single uniform value.
 */
class AGlUniformValue {
    constructor(name, data) {
        this.name = name;
        this.data = data;
        this.isDirty = true;
        this.uniformLocation = null;
    }
    onContextLost() {
        this.isDirty = true;
        this.uniformLocation = null;
    }
    initialize(componentRenderer) {
        componentRenderer.addUniform(this);
        this.uniformLocation = componentRenderer.context.getUniformLocation(componentRenderer.program, this.name);
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            if (this.uniformLocation == null) {
                rc_js_util_1._Debug.verboseLog(`failed to bind uniform "${this.name}" of type "${this.data.constructor.name}"`);
            }
        });
    }
    setData(data) {
        if (this.data !== data) {
            this.data = data;
            this.isDirty = true;
        }
    }
}
exports.AGlUniformValue = AGlUniformValue;
//# sourceMappingURL=a-gl-uniform-value.js.map